/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planstatusactive2Inputs */

const en_planstatusactive2 = /** @type {(inputs: Planstatusactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_planstatusactive2 = /** @type {(inputs: Planstatusactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Planstatusactive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planstatusactive2 = /** @type {((inputs?: Planstatusactive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planstatusactive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planstatusactive2(inputs)
	return de_planstatusactive2(inputs)
});
export { planstatusactive2 as "planStatusActive" }